import { render } from "./MovementForm.vue?vue&type=template&id=36dab412&scoped=true&ts=true"
import script from "./MovementForm.vue?vue&type=script&lang=ts"
export * from "./MovementForm.vue?vue&type=script&lang=ts"

import "./MovementForm.vue?vue&type=style&index=0&id=36dab412&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36dab412"]])

export default __exports__